const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

export const parseInstrumentToken = (value) => {
  if (typeof value === 'number') {
    return Number.isSafeInteger(value) && value > 0 ? value : null;
  }

  if (typeof value === 'string' && /^[1-9]\d*$/.test(value)) {
    const token = Number(value);
    return Number.isSafeInteger(token) ? token : null;
  }

  return null;
};

export const parseTickNumber = (value) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;
    if (!/^[+-]?(?:\d+\.?\d*|\.\d+)$/.test(trimmed)) return null;
    const number = Number(trimmed);
    return Number.isFinite(number) ? number : null;
  }

  return null;
};

const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

const readNumber = (object, key) => {
  if (!isPlainObject(object) || !hasOwn(object, key)) return null;
  return parseTickNumber(object[key]);
};

export const normalizeTick = (tick) => {
  if (!isPlainObject(tick)) return null;

  const instrumentToken = parseInstrumentToken(tick.instrument_token ?? tick.token);
  if (!instrumentToken) return null;

  const lastPrice = parseTickNumber(tick.last_price ?? tick.ltp);
  if (lastPrice === null) return null;

  const normalized = {
    ...tick,
    instrument_token: instrumentToken,
    last_price: lastPrice,
    ohlc: {},
  };

  const sourceOhlc = isPlainObject(tick.ohlc) ? tick.ohlc : {};
  ['open', 'high', 'low', 'close'].forEach((key) => {
    const nestedValue = readNumber(sourceOhlc, key);
    const value = nestedValue !== null ? nestedValue : readNumber(tick, key);
    if (value !== null) normalized.ohlc[key] = value;
  });

  const change = parseTickNumber(tick.change);
  if (change !== null) normalized.change = change;

  const ts = parseTickNumber(tick.ts);
  if (ts !== null) normalized.ts = ts;

  return normalized;
};

export const extractNormalizedTicksFromMessage = (message) => {
  if (!isPlainObject(message)) return [];

  if (message.type === 'tick') {
    const tick = normalizeTick(message.payload);
    return tick ? [tick] : [];
  }

  if (message.type === 'tick.batch' && Array.isArray(message.ticks)) {
    return message.ticks.map(normalizeTick).filter(Boolean);
  }

  const tick = normalizeTick(message);
  return tick ? [tick] : [];
};
